const API_BASE_URL = process.env.BASE_URL

export const USER_PREFERENCES = {
    UPLOAD_USER_AVATAR: API_BASE_URL + "/user/me/upload-avatar/",
    DELETE_USER_AVATAR: API_BASE_URL + "/user/me/remove-avatar/",
}
